export default "__VITE_ASSET__a051dd3b__"